
<template>
<section>
  <li class="ageWarning">
    <fieldset>
      <ol class="questions">
        <li>
          <div class="status info">
            <h3>Under marriageable age</h3>
            <p>
              Court approval and consents or dispensations are required
              for a person under 18 years. Please email bdmceremonies@justice.qld.gov.au
            </p>
          </div>
        </li>
      </ol>
    </fieldset>
  </li>
</section>
</template>
<script> 
export default {
  props: {
    number: String
  }
}
</script>